var render, staticRenderFns
import script from "./Crosshair.vue?vue&type=script&lang=js&"
export * from "./Crosshair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bsjung/work/xtc/trading-chart-js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d394f22')) {
      api.createRecord('5d394f22', component.options)
    } else {
      api.reload('5d394f22', component.options)
    }
    
  }
}
component.options.__file = "src/components/Crosshair.vue"
export default component.exports